import {
  Container,
  Typography,
  Card,
  CardContent,
  Avatar,
  Divider,
} from "@mui/material";
import './equipo.css';
import topo from "../assets/gallery/topo.gif";
import angel from "../assets/team/angel.png";
import elmer from "../assets/team/elmer.jpg";
import jaziel from "../assets/team/jaziel.jpg";
import marcos from "../assets/team/marcos.jpg";
import raul from "../assets/team/raul.jpg";
import "../App.css";
const TEAM = [
  { name: "Marcos", position: "Jefe desarrollador", avatar: marcos },
  { name: "Angel", position: "Desarrollador", avatar: angel },
  { name: "Jaziel", position: "Jefe de proyecto", avatar: jaziel },
  { name: "Daniel", position: "Desarrollador", avatar: topo },
  { name: "Raul", position: "Desarrollador", avatar: raul },
  { name: "Elmer", position: "Desarrollador", avatar: elmer },
  { name: "Irving", position: "Diseño de niveles", avatar: topo },
];
export default function Equipo() {
  const GenerateCards = () => {
    const teamItems = TEAM.map((item, index) => {
      return (
        <Card
          className="card"
          sx={{
            maxWidth: 200,
            margin: "2%",
            padding: "2%",
            minWidth: 100,
            textAlign: "center",
            justifyContent: "center",


          }}
          data-aos="flip-left"
          data-aos-duration="1500"
          key={index}
        >
          <CardContent className="contentCard">
            <Avatar
              alt={item.name}
              src={item.avatar}
              sx={{ width: 80, height: 90, alignSelf: "center", display: {md:'block',xs:"none"}, margin: 'auto' }}

            />
             <Avatar
              alt={item.name}
              src={item.avatar}
              sx={{ width: 60, height: 70, alignSelf: "center", display: {md:'none',xs:"block"}, margin: 'auto' }}

            />
            <Typography variant="subtitle1">{item.name}</Typography>
            <Typography variant="body1">{item.position}</Typography>
          </CardContent>
        </Card >
      );
    });
    return (
      <Container
        sx={{
          display: { xs: "flex", md: "flex" },
          width: "100%",
          alignItems: "center",
          textAlign: "center",
          flexWrap: "wrap",
          justifyContent: "center",
        }}
      >
        {teamItems}
      </Container>
    );
  };

  return (
    <Container
      sx={{
        display: "block",
        width: "80%",
        textAlign: "center",
        marginTop: 1,
        paddingBottom: 10,
      }}
      id="equipo"
    >
      <Typography variant="h2">Equipo</Typography>
      <GenerateCards />
      <Divider />
    </Container>
  );
}
